// frontend/src/api/contactService.ts
import apiClient from "./index";
import {
  type ContactFormPayload,
  type ContactResponse,
  type ContactStatus,
  type ContactStatusUpdatePayload,
  // GetContactSubmissionsParams is likely already defined if getContactSubmissions exists
} from "@/types";

// Ensure GetContactSubmissionsParams is defined or imported if not already.
// It's used by getContactSubmissions. A similar one is needed for the count.
export interface GetContactSubmissionsParams {
  skip?: number;
  limit?: number;
  status?: ContactStatus | "";
}

export const submitContactForm = async (
  formData: ContactFormPayload
): Promise<ContactResponse> => {
  const response = await apiClient.post<ContactResponse>(
    "/contact-submissions/",
    formData
  );
  return response.data;
};

export const getContactSubmissions = async (
  params: GetContactSubmissionsParams
): Promise<ContactResponse[]> => {
  const queryParams = new URLSearchParams();
  if (params.skip !== undefined) queryParams.append("skip", String(params.skip));
  if (params.limit !== undefined) queryParams.append("limit", String(params.limit));
  if (params.status) queryParams.append("status", params.status);

  const response = await apiClient.get<ContactResponse[]>(
    `/contact-submissions/?${queryParams.toString()}`
  );
  return response.data;
};

export const updateContactSubmissionStatus = async (
  submissionId: number,
  payload: ContactStatusUpdatePayload
): Promise<ContactResponse> => {
  const response = await apiClient.put<ContactResponse>(
    `/contact-submissions/${submissionId}`,
    payload
  );
  return response.data;
};

export const deleteContactSubmission = async (
  submissionId: number
): Promise<void> => {
  await apiClient.delete(`/contact-submissions/${submissionId}`);
};


// --- ADD THIS NEW FUNCTION ---
export interface GetContactSubmissionsCountParams {
  status?: ContactStatus | ""; // "" means no specific status filter (total count for all)
}

interface CountResponseData { // To match the backend's response for the count
  total: number;
}

export const getContactSubmissionsCount = async (
  params: GetContactSubmissionsCountParams
): Promise<CountResponseData> => {
  const queryParams = new URLSearchParams();
  if (params.status) { // Only add status if it's a non-empty string
    queryParams.append("status", params.status);
  }

  const response = await apiClient.get<CountResponseData>(
    // Ensure this matches the count endpoint you created on the backend
    `/contact-submissions/count?${queryParams.toString()}`
  );
  return response.data; // Expected to be an object like { total: 123 }
};
// --- END OF NEW FUNCTION ---